import type { ApolloError } from '@apollo/client';

import { isGraphQLAuthError } from 'src/modules/error-handling/error-handling';
import type { Maybe } from 'src/types';
import type * as Schema from 'src/types/graphql';

import { Actions, type SkillsAction } from './actions';

export const updateSkills = (
  skills: Schema.Skill[],
  suggestedSkillsAdded: Maybe<number>,
): SkillsAction => ({
  type: Actions.UPDATE_SKILLS_START,
  payload: { skills, suggestedSkillsAdded },
});

export const updateSkillsSuccess = (): SkillsAction => ({
  type: Actions.UPDATE_SKILLS_SUCCESS,
  meta: {
    metrics: {
      'profile-update': true,
    },
  },
});

export const updateSkillsFailure = (error: ApolloError): SkillsAction => ({
  type: Actions.UPDATE_SKILLS_FAILURE,
  payload: error,
  meta: {
    metrics: {
      error: !isGraphQLAuthError(error),
    },
  },
});
